// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Empty_wrap__vyapw","icon":"Empty_icon__qDJg_","title":"Empty_title__8fxYU","description":"Empty_description__yRxZb","button":"Empty_button__vxwXn"};